import { mutatorAction } from 'satcheljs';
import getFeedbackRibbonState from '../selectors/getFeedbackRibbonState';

export let setShowThankyouMessage = mutatorAction(
    'setShowThankyouMessage',
    (showThankYouMessage: boolean, sessionId: string) => {
        getFeedbackRibbonState(sessionId).showThankYouMessage = showThankYouMessage;
    }
);
